// Règle pure : le participant courant peut-il écrire dans cette conversation ?
//
// Extraite de FloatingConversationWindow pour être testée sans DOM.
//
// DEUX ÉTATS DISTINCTS d'un interlocuteur absent de `members` :
//   - compte EFFACÉ (RGPD) : la conversation est en LECTURE SEULE. Le serveur le dit explicitement (`readOnly === true`),
//     raison `other_unavailable` ;
//   - conversation simplement MASQUÉE par l'interlocuteur : il existe toujours et reste joignable. Les listes `members`
//     omettent les participants masqués, donc son absence de `members` ne prouve RIEN. Quand le serveur répond
//     `readOnly === false`, on ne déduit donc plus rien de l'absence : seules les conditions de l'utilisateur courant
//     et celles de l'interlocuteur CONNU s'appliquent.
// Sans drapeau (`readOnly` indéfini : conversation fabriquée côté client, ancienne réponse), on garde la règle historique
// prudente : interlocuteur absent = envoi bloqué (`other_unavailable`).

export function resolveSendEligibility({ conversation, currentUser }) {
  const currentUserValidated = currentUser?.validated
  const currentUserProfileComplete = currentUser?.isProfileVerified

  const selfReason = () => {
    if (!currentUserValidated) return 'current_not_validated'
    if (!currentUserProfileComplete) return 'current_profile_incomplete'
    return null
  }

  // Groupe : seul l'utilisateur courant est vérifié.
  if (conversation?.type === 'group') {
    const reason = selfReason()
    return { canSendMessage: reason === null, disabledReason: reason }
  }

  const reason = selfReason()
  if (reason) return { canSendMessage: false, disabledReason: reason }

  // Le serveur est l'autorité sur l'état du COMPTE : lecture seule explicite.
  if (conversation?.readOnly === true)
    return { canSendMessage: false, disabledReason: 'other_unavailable' }

  const other = conversation?.members?.find((m) => m.id !== currentUser?.id)
  if (!other) {
    // Interlocuteur absent de la liste : masqué (readOnly === false, joignable) ou inconnu (pas de drapeau, prudence).
    return conversation?.readOnly === false
      ? { canSendMessage: true, disabledReason: null }
      : { canSendMessage: false, disabledReason: 'other_unavailable' }
  }
  if (!other.validated) return { canSendMessage: false, disabledReason: 'other_not_validated' }
  if (!other.isProfileVerified)
    return { canSendMessage: false, disabledReason: 'other_profile_incomplete' }
  return { canSendMessage: true, disabledReason: null }
}

// Refus serveur « lecture seule » (interlocuteur effacé pendant que la fenêtre était ouverte).
export function isReadOnlyError(error) {
  return error?.status === 409 && error?.code === 'CONVERSATION_READ_ONLY'
}
